// extracted by mini-css-extract-plugin
export default {"blockAbout":"BlockAbout_blockAbout__Zgozl","title":"BlockAbout_title__FGiv9","supportInfo":"BlockAbout_supportInfo__DJ3B6"};